<template>
    <svg :class="rotate" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 6L9 12L15 18" :stroke="stroke ? stroke : '#212121'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script setup lang="ts">

    type Props = {
        stroke?: string,
        direction?: 'left'|'top'|'right'|'bottom',
    }

    const { stroke, direction } = defineProps<Props>();

    const rotate = computed(() => {
        switch (direction) {
            case 'left': {
                return 'rotate-0';
            }
            case 'top': {
                return 'rotate-90';
            }
            case 'right': {
                return 'rotate-180';
            }
            case 'bottom': {
                return '-rotate-90';
            }
            default: {
                return 'rotate-0';
            }
        }
    });
</script>